<template>
  <div class="p-4 bg-light min-vh-100">
    <!-- <div class="d-flex justify-content-between mb-4">
      <h3 class="text-cyan fw-bold">Mijozni Tahrirlash</h3>
      <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary" @click="$router.push('/malumot/kontragent/index')">Chiqish</button>
        <button class="btn btn-success px-4" @click="$root.$refs.kontragent.Savedokument()">O'zgarishlarni
          saqlash</button>
      </div>
    </div> -->

    <kontragent-form v-if="loaded" :datas="dataall"></kontragent-form>
  </div>
</template>

<script>
import { KontragentForm } from "@/pages";

export default {
  components: { KontragentForm },
  data() {
    return {
      dataall: {},
      loaded: false
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      axios.get(`api/v1/kontragent/id/${this.$route.params.id}`).then(res => {
        this.dataall = res.data;
        this.loaded = true;
        this.$store.state.saved = 0; // Yuklangandan keyin saqlash counterini nolga tushiramiz
      });
    }
  }
};
</script>